import { forOwn, size } from 'lodash';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { range, required, testRegex } from '../../../../../../common/services/ValidationRules';
import { controllerTypeMap } from '../../constants';
import { ClearRejectedConfigurationParameterButton } from '../fields/ClearRejectedConfigurationParameterButton';

export const getFieldComponent = (controllerType, dataType, availableValues) => {
  if (controllerType && controllerTypeMap[controllerType]) {
    return controllerTypeMap[controllerType];
  }

  if (dataType && controllerTypeMap[dataType]) {
    return controllerTypeMap[dataType];
  }

  if (size(availableValues)) {
    return controllerTypeMap.SELECT;
  }

  return controllerTypeMap.TEXT_FIELD;
};

export const getValidations = (validations) => {
  const validationArray = [];

  forOwn(validations, (validation, key) => {
    switch (key) {
      case 'regex':
        if (validation) {
          validationArray.push(testRegex(validation));
        }
        break;
      case 'required':
        if (validation) {
          validationArray.push(required);
        }
        break;
      case 'range':
        if (validation) {
          validationArray.push(range(validation));
        }
        break;
      default:
        break;
    }
  });

  return validationArray;
};

export const clearButtonComponent = (isReadOnly, resetField, cancelChanges, onClickCallback) => (status) => (
  <ClearRejectedConfigurationParameterButton
    disabled={isReadOnly}
    status={status}
    onClearRejected={resetField}
    onCancelClick={() => {
      cancelChanges()
      onClickCallback && onClickCallback()
    }}
  />)

export const clearBatchUpdateButtonComponent = (onBatchFieldChange) => (touched) => (
  <IconButton size="small" disabled={touched} onClick={onBatchFieldChange}>
    <EditIcon />
  </IconButton>
);
